/* VÆLD — header behavior.
   - On scroll down: hide. On scroll up: show. Always show near top.
   - Mobile menu toggle. */

(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  if (!header) return;

  // --- Scroll hide / show ----------------------------------------------------
  var lastY = window.scrollY;
  var threshold = 12;
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      var delta = y - lastY;

      header.classList.toggle('is-scrolled', y > 24);

      if (y < 60) {
        header.classList.remove('is-hidden');
      } else if (delta > threshold) {
        header.classList.add('is-hidden');
      } else if (delta < -threshold) {
        header.classList.remove('is-hidden');
      }

      lastY = y;
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // --- Mega menu (aria + Escape; open/close is CSS hover/focus) --------------
  var megaItems = document.querySelectorAll('[data-mega-item]');
  megaItems.forEach(function (item) {
    var trigger = item.querySelector('[data-mega-trigger]');
    if (!trigger) return;
    function expand(state) { trigger.setAttribute('aria-expanded', state ? 'true' : 'false'); }
    item.addEventListener('mouseenter', function () { expand(true); });
    item.addEventListener('mouseleave', function () { expand(false); });
    item.addEventListener('focusin', function () { expand(true); });
    item.addEventListener('focusout', function () {
      if (!item.contains(document.activeElement)) expand(false);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    megaItems.forEach(function (item) {
      var t = item.querySelector('[data-mega-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (item.contains(document.activeElement)) document.activeElement.blur();
    });
  });

  // --- Mobile menu -----------------------------------------------------------
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    var lastFocus = null;

    function openMenu() {
      lastFocus = document.activeElement;
      toggle.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
      menu.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      // Focus first link for keyboard users
      var firstLink = menu.querySelector('a');
      if (firstLink) setTimeout(function () { firstLink.focus(); }, 200);
    }

    function closeMenu() {
      toggle.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
      menu.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') closeMenu();
      else openMenu();
    });

    // Close on link click (navigation continues normally)
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    // Esc to close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });

    // Close if we resize past mobile breakpoint
    window.addEventListener('resize', function () {
      if (window.innerWidth > 760 && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }
})();
